import * as React from 'react'
import { Clipboard } from 'react-feather'

import { Strong, Text } from 'main/ui'
import { useTranslation } from 'react-i18next'
import { LOCIZE_NAMESPACE } from '../../../common'

import Bullet from '../common/Bullet'
import { i18nKeyPrefix } from '../i18n'

const PRE = `${i18nKeyPrefix}-BASICS-PHILOSOPHY`

interface IProps {
  philosophy: string
  philosophySecondary: string | null
}

export default function Philosophy(props: IProps) {
  const { philosophy, philosophySecondary } = props
  const { t } = useTranslation(LOCIZE_NAMESPACE)

  return (
    <Bullet icon={<Clipboard />}>
      <Strong>{t(`${PRE}-TEXT`)}</Strong>
      <Text muted>
        {philosophyLabel(philosophy)}
        {philosophySecondary && `, ${philosophySecondary}`}
      </Text>
    </Bullet>
  )

  function philosophyLabel(key: string) {
    switch (key) {
      case 'hidden':
        return t(`${PRE}-HIDDEN`)
      case 'play_based':
        return t(`${PRE}-PLAY-BASED`)
      case 'montessori':
        return t(`${PRE}-MONTESSORI`)
      case 'montessori_inspired':
        return t(`${PRE}-MONTESSORI-INSPIRED`)
      case 'reggio_emilia_inspired':
        return t(`${PRE}-REGGIO-EMILIA-INSPIRED`)
      case 'rie_inspired':
        return t(`${PRE}-RIE-INSPIRED`)
      case 'waldorf':
        return t(`${PRE}-WALDORF`)
      case 'waldorf_inspired':
        return t(`${PRE}-WALDORF-INSPIRED`)
      case 'nature_based':
        return t(`${PRE}-NATURE-BASED`)
      case 'stem':
        return t(`${PRE}-STEM`)
      case 'steam':
        return t(`${PRE}-STEAM`)
      case 'bilingual':
        return t(`${PRE}-BILINGUAL`)
      case 'language_immersion':
        return t(`${PRE}-LANGUAGE-IMMERSION`)
      default:
        throw new Error(`unsupported philosophy: ${key}`)
    }
  }
}
